import { useRef, useState, useEffect } from "react";
import  '../../css/Switch.css';

/*
 * Read the blog post here:
 * https://letsbuildui.dev/articles/building-a-segmented-control-component
 */
const Swicth = ({
  descricao,
  name,
  segments,
  callback,
  defaultIndex,
  controlRef,
  w = 55
}) => {
  const [activeIndex, setActiveIndex] = useState(defaultIndex);
  const componentReady = useRef();

  // Determine when the component is "ready"
  useEffect(() => {
    componentReady.current = true;
  }, []);

  useEffect(() => {
    const activeSegmentRef = segments[activeIndex].ref;
    const { offsetWidth, offsetLeft } = activeSegmentRef.current;
    const { style } = controlRef.current;

    style.setProperty("--highlight-width", `${offsetWidth}px`);
    style.setProperty("--highlight-x-pos", `${offsetLeft}px`);
  }, [activeIndex, callback, controlRef, segments]);

  const onInputChange = (value, index) => {
    setActiveIndex(index);
    callback(value, index);
  };

  function teste(){
    if (activeIndex === 1){
      setActiveIndex(0)
      callback(0, 0);
    }else{
      setActiveIndex(1)
      callback(1, 1);
    }
  }

  return (
    <div className="controls-containerSwitch" ref={controlRef}>
        <div style={{width: `${w}%`, textAlign: 'left'}} >{descricao}</div>
      <div className={`controlsSwitch ${activeIndex === 1 ? "On" : "Off"}`} onClick={teste}>
        {segments?.map((item, i) => (
          <div
            key={item.value}
            className={`segmentSwitch ${i === activeIndex ? "active" : "inactive"}`}
            ref={item.ref}
            
          >
            <input
              type="radio"
              value={item.value}
              id={item.label}
              name={name}
              onChange={() => onInputChange(item.value, i)}
              checked={i === activeIndex}
              
            />
            <label htmlFor={item.label} >{item.label}</label>
          </div>
        ))}
      </div>
     
    </div>
  );
};

export default Swicth;

